/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-cycle */
import React, { ChangeEvent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from '../..';
import Button from '../../UI/button/buttonComponent';
import { BUTTON_TYPE, BUTTON_VER } from '../../UI/button/buttonTypes';
import style from './adminPage.module.scss';
import {
  countUsers,
  deleteUser,
  factoryReset,
  findUser,
  getAllUsers,
  signOut,
} from '../../service/UserData';
import Input from '../../UI/input/inputComponent';
import { INPUT_TYPE } from '../../UI/input/inputTypes';
import { timeSinceLastOnline } from '../../utility/utility';
import { countOffers, resetOffers } from '../../service/ListingData';

const AdminPage: React.FC = () => {
  const dispatch = useDispatch();
  const totalUsers = useSelector((state) => state.userData.totalUsers);
  const users = useSelector((state) => state.userData.users);
  const totalOffers = useSelector((state) => state.listingData.totalOffers);

  const FR = () => {
    const actionResult = dispatch(factoryReset());
    if (factoryReset.fulfilled.match(actionResult)) {
      dispatch(signOut({ token: 'TOKEN' }));
    }
  };
  useEffect(() => {
    dispatch(countOffers());
    dispatch(countUsers());
    dispatch(getAllUsers());
  }, []);
  const userDelete = async (id: number) => {
    const resultAction = await dispatch(deleteUser(id));
    if (deleteUser.fulfilled.match(resultAction)) {
      dispatch(countOffers());
      dispatch(countUsers());
    }
  };
  const offersReset = () => {
    dispatch(resetOffers());
  };
  const [searchData, setSearchData] = useState<string>('');

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchData(e.target.value);
  };

  return (
    <div className={style.shell}>
      <div className={style.secondShell}>
        <div className={style.textShell}>
          <h1 className={totalUsers < 100 ? style.h1 : style.h1c}>
            {totalUsers}
          </h1>
          <p className={style.p}>Юзеров в системе</p>
        </div>
        <div className={style.textShell}>
          <h1 className={totalOffers < 1000 ? style.h1 : style.h1c}>
            {totalOffers}
          </h1>
          <p className={style.p}>Объявлений в системе</p>
        </div>
      </div>
      <div className={style.thirdShell}>
        <Button
          text="Сброс Объявлений"
          ver={BUTTON_VER.primary}
          type={BUTTON_TYPE.Button}
          onClick={offersReset}
        />
        <Button
          text="Полный Сброс"
          ver={BUTTON_VER.secondary}
          type={BUTTON_TYPE.Button}
          onClick={FR}
        />
      </div>
      <div className={style.fourthShell}>
        <Input
          ver={INPUT_TYPE.SEARCH}
          placeholder="Email..."
          customWidth={900}
          errStatus={false}
          onChange={handleChange}
          name="name"
          customMargin={0}
          onSearch={() => dispatch(findUser(searchData))}
        />
        {users !== null
          ? users.map((u) => (
              <div className={style.fourthShellRow}>
                <div
                  className={
                    timeSinceLastOnline(u.lastOnline).count < 30
                      ? style.userShell
                      : style.userShellE
                  }
                >
                  <div className={style.flexRow}>
                    <h2 className={style.h2}>{u.name}</h2>
                    <h2 className={style.h2}>{u.email}</h2>
                  </div>
                  <span
                    className={
                      timeSinceLastOnline(u.lastOnline).count < 30
                        ? style.span
                        : style.spanE
                    }
                  >
                    {timeSinceLastOnline(u.lastOnline).text}
                  </span>
                </div>
                <Button
                  ver={BUTTON_VER.primary}
                  text="Удалить"
                  type={BUTTON_TYPE.Button}
                  customWidth={220}
                  onClick={() => userDelete(u.id)}
                  disabled={u.admin}
                />
              </div>
            ))
          : null}
      </div>
    </div>
  );
};

export default AdminPage;
